import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { ClientService } from "../../../../../../services/clientService";
import NotificationManager from "react-notifications/lib/NotificationManager";
import APP_ROUTES from "src/helper/app-routes";
import RecentIssue from "./recent-issues";
import Interference from "./cats-interference";
import { useLocation } from "react-router";
// import InputKendoRct from "../../../control-components/input/input";
import InputKendoRct from "src/control-components/input/input";
import { renderErrors } from "src/helper/error-message-helper";
import ClientQuestionnaireService from "./functionToSaveQuestionnaireFromPortal";
import TextAreaKendoRct from "src/control-components/text-area/text-area";

const ASQ = ({
  list,
  questionId,
  subList,
  interfered,
  response,
  isPrint,
  isFromCP,
  token,
   queId
}) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const selectedClientId = useSelector((state) => state.selectedClientId);
  const [loading, setLoading] = useState(false);
  const [selectedValues, setSelectedValues] = useState([]);
  const [listItems, setListItems] = useState(list);
  const [q5Details, setQ5Details] = useState({
    questionId: "q5Detail",
    value: "",
  });
  const [q4Details, setQ4Details] = useState({
    questionId: "q4Detail",
    value: "",
  });

  const [fields, setFields] = useState({
    event: "",
    brother: "",
  });

  const totalSum = listItems?.reduce(
    (sum, item) => sum + (Number(item.value) || 0),
    0
  );

  useEffect(() => {
    const l1 = listItems.map((item) => {
      const foundItem = response.find((i) => i.questionId === item.questionId);
      if (foundItem) {
        if (item.type === "question") {
          const [firstValue] = foundItem.value ? foundItem.value.split(",").map(v => v.trim()) : [null];
            return {
              ...item,
              isSelected: firstValue === "true" ? true : firstValue === "false" ? false : null,
              value: foundItem.value || "null,",
            };
          }
        return { ...item, ...foundItem };
      } else {
        return item;
      }
    });

    const q4 = response.find(
      (i) => i.questionId === q4Details.questionId
    );
    const q5 = response.find(
      (i) => i.questionId === q5Details.questionId
    );
    setTimeout(() => {
      setListItems(l1);
      if (q4) {
        setQ4Details(q4);
      }
      if (q5) {
        setQ5Details(q5);
      }
    }, 0);
  }, [response]);

  const handleRadioChange = (itemId, value) => {
    const updatedItems = listItems.map((item) => {
      if (item.questionId === itemId) {
        return { ...item, value: value };
      }
      return item;
    });
    setListItems(updatedItems);
  };
  
  
  const handleSubmit = async () => {
    await ClientService.insertClientQuestionnaire(
      selectedClientId,
      totalSum,
      [...listItems, q4Details, q5Details],
      questionId,
      queId,
      token
    )
      .then((result) => {
        let questionList = result.resultData;
        navigate(APP_ROUTES.QUESTIONNAIRE);
        NotificationManager.success("Add successfully");
      })
      .catch((error) => {
        setLoading(false);
        renderErrors(error.message);
      });
  };

  // const arr = Object.entries(selectedValues).map(([key, value]) => {
  //   return { key: parseInt(key), value };
  // });

  const condition = "true";
  const condition2 = "1";
  const condition3 = "0"
  const condition4 = "false"
  const foundItem = listItems?.find((item) => item.value === condition || item.value === condition2  || item.value === condition3 || item.value === condition4);



  const handleSaveFromPortal = async () => {
    ClientQuestionnaireService.updatequestionnaireFromPortal(selectedClientId, totalSum, 
      [...listItems, q4Details, q5Details]
      , queId, token)
  }

  const handleCompleteFromPortal = async () => {
    try {
      ClientQuestionnaireService.completeQuestionnaireFromPortal(false, queId, selectedClientId, totalSum, 
        [...listItems, q4Details, q5Details]
        ,  {isCompleted: true, inProgress: false, sentToClientPortal: null}, token)
    } catch (error) {
      console.error('Error completing client questionnaire:', error);
      NotificationManager.error('Failed to complete client questionnaire');
    }
  };
  
  function handleTextChange(e) {
    if(e?.target?.name === "q4") {
      setQ4Details((prev) => ({
        ...prev,
        value: e?.target?.value
      }))
    }
    else {
      setQ5Details((prev) => ({
        ...prev,
        value: e?.target?.value
      }))
    }
  }

  return (
    <div className="child_main_table mt-3 col-12">
      <div>
        <div className="head-4">Suicide Risk Screening Tool</div>
      </div>
  
      {isPrint ? (
        (() => {
          const isAnyYes = listItems
            .filter((i) => ["ASQ_Q1", "ASQ_Q2", "ASQ_Q3", "ASQ_Q4"].includes(i.questionId))
            .some((i) => i.value === "true" || i.isSelected === true);
  
          return (foundItem || listItems[listItems.length - 1].isSelected) ? (
            <>
              {listItems.map((item) => {
                const isQ4 = item.questionId === "ASQ_Q4";
                const isQ5 = item.questionId === "ASQ_Q5";
  
                if (isQ5 && !isAnyYes) return null;
  
                return (
                  <div className="row mb-3 py-2 border-bottom" key={item.id}>
                    <div className="col-12">
                      <label>{item.id}. {item.name}</label>
                    </div>
                    <div className="col-12 select_table_phq select-table-drops d-flex align-items-baseline gap-2">
                      <div>
                      <input
                        type="radio"
                        name={`radio_${item.questionId}`}
                        value="true"
                        checked={item?.type === "question" ? item.isSelected : item.value === "true"}
                        onChange={() => handleRadioChange(item.questionId, "true")}
                        className="input_box_cats"
                      />
                      <label className="mr-3">Yes</label>
                      </div>
                      <div>
                      <input
                        type="radio"
                        name={`radio_${item.questionId}`}
                        value="false"
                        checked={
                          item?.type === "question"
                            ? item.isSelected === null
                              ? false
                              : !item.isSelected
                            : item.value === "false"
                        }
                        onChange={() => handleRadioChange(item.questionId, "false")}
                        className="input_box_cats"
                      />
                      <label className="mr-3">No</label>
                      </div>
                    </div>
  
                    {isQ4 && (item.isSelected || item.value === "true") && (
                      <div className="ml-3 flex-grow-1">
                        <TextAreaKendoRct
                          name="q4"
                          rows={1}
                          label="Please Describe"
                          txtValue={q4Details?.value}
                          onChange={handleTextChange}
                        />
                      </div>
                    )}
                    {isQ5 && (item.isSelected || item.value === "true") && (
                      <div className="ml-3 flex-grow-1">
                        <TextAreaKendoRct
                          name="q5"
                          rows={1}
                          label="Please Describe"
                          txtValue={q5Details?.value}
                          onChange={handleTextChange}
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          ) : null;
        })()
      ) : (
        listItems.map((item) => {
          const isQ4 = item.questionId === "ASQ_Q4";
          const isQ5 = item.questionId === "ASQ_Q5";
          const isAnyYes = listItems
            .filter((i) => ["ASQ_Q1", "ASQ_Q2", "ASQ_Q3", "ASQ_Q4"].includes(i.questionId))
            .some((i) => i.value === "true" || i.isSelected === true);
  
          if (isQ5 && !isAnyYes) return null;
  
          return (
            <div className="row mb-3 py-2 border-bottom" key={item.id}>
              <div className="col-12">
                <label>{item.id}. {item.name}</label>
              </div>
              <div className="col-12 select_table_phq select-table-drops d-flex align-items-baseline gap-2">
                <div>
                  <input
                    type="radio"
                    name={`radio_${item.questionId}`}
                    value="true"
                    checked={item?.type === "question" ? item.isSelected : item.value === "true"}
                    onChange={() => handleRadioChange(item.questionId, "true")}
                    className="input_box_cats"
                  />
                  <label className="mr-3">Yes</label>
                  <input
                    type="radio"
                    name={`radio_${item.questionId}`}
                    value="false"
                    checked={
                      item?.type === "question"
                        ? item.isSelected === null
                          ? false
                          : !item.isSelected
                        : item.value === "false"
                    }
                    onChange={() => handleRadioChange(item.questionId, "false")}
                    className="input_box_cats"
                  />
                  <label className="mr-3">No</label>
                </div>
  
                {isQ4 && (item.isSelected || item.value === "true") && (
                  <div className="ml-3 flex-grow-1">
                    <TextAreaKendoRct
                      name="q4"
                      rows={1}
                      label="Please Describe"
                      txtValue={q4Details?.value}
                      onChange={handleTextChange}
                    />
                  </div>
                )}
                {isQ5 && (item.isSelected || item.value === "true") && (
                  <div className="ml-3 flex-grow-1">
                    <TextAreaKendoRct
                      name="q5"
                      rows={1}
                      label="Please Describe"
                      txtValue={q5Details?.value}
                      onChange={handleTextChange}
                    />
                  </div>
                )}
              </div>
            </div>
          );
        })
      )}
  
      <div>
        <div><b>Next steps</b></div>
        <ul>
          <li className="px-2 py-2">
            If patient answers “No” to all questions 1 through 4, screening is complete (not necessary to ask question #5).
            No intervention is necessary (*Note: Clinical judgment can always override a negative screen).
          </li>
          <li className="px-2 py-2">
            If patient answers “Yes” to any of questions 1 through 4, or refuses to answer, they are considered a
            positive screen. Ask question #5 to assess acuity:
          </li>
          <span className="px-2 py-2">
            “Yes” to question #5 = acute positive screen (imminent risk identified)
            <ul>
              <li>Patient requires a STAT safety/full mental health evaluation. <br />Patient cannot leave until evaluated for safety.</li>
              <li>Keep patient in sight. Remove all dangerous objects from room. Alert physician or clinician responsible for patient's care</li>
            </ul>
          </span>
          <span className="px-2 py-2">
            “No” to question #5 = non-acute positive screen (potential risk identified)
            <ul>
              <li className="px-2 py-2">
                Patient requires a brief suicide safety assessment to determine if a full mental health evaluation
                <br />is needed. Patient cannot leave until evaluated for safety.
              </li>
              <li className="px-2 py-2">
                Alert physician or clinician responsible for patient’s care.
              </li>
            </ul>
          </span>
        </ul>
      </div>
  
      <div>
        <div><b>Provide resources to all patients</b></div>
        <ul>
          <li className="px-2 py-2">24/7 National Suicide Prevention Lifeline 1-800-273-TALK (8255) En Español: 1-888-628-9454</li>
          <li className="px-2 py-2">24/7 Crisis Text Line: Text “HOME” to 741-741</li>
        </ul>
      </div>
  
      {isFromCP ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleCompleteFromPortal} className="submitButon">Save & Complete</button>
          <button onClick={handleSaveFromPortal} className="cancelBtn">Save progress</button>
        </div>
      ) : state == null && !isPrint ? (
        <div className="text-start mt-3 col-12">
          <button onClick={handleSubmit} className="submitButon">Submit</button>
        </div>
      ) : null}
    </div>
  );
  
};

export default ASQ;
